import { render, staticRenderFns } from "./step-exterior-header.vue?vue&type=template&id=71924630"
import script from "./step-exterior-header.vue?vue&type=script&lang=ts"
export * from "./step-exterior-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports